import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const selectedTimeFrametStatusFilterSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.selectedTimeFrameStatusFilter,
);

export default selectedTimeFrametStatusFilterSelector;
